/**
 * Display helpers for the workout statistics tab. Volume formatting mirrors the
 * reusable WorkoutRow card so the numbers read the same across the page.
 */

export const formatVolume = (kg: number): string =>
  `${Math.round(kg || 0).toLocaleString("bg-BG")} кг`;

/**
 * Backend dates are UTC with no timezone marker; append "Z" so JS doesn't read them
 * as local time. Same workaround as GymPage / AuditTimeline.
 */
const parseUtc = (iso: string): Date => {
  const withZone = /[zZ]|[+-]\d{2}:?\d{2}$/.test(iso) ? iso : `${iso}Z`;
  return new Date(withZone);
};

/** Short "5.06" style label for chart axes. */
export const shortDate = (iso: string): string => {
  const date = parseUtc(iso);
  if (isNaN(date.getTime())) return "";
  return `${date.getDate()}.${String(date.getMonth() + 1).padStart(2, "0")}`;
};
